import { __awaiter, __generator } from "tslib";
import { fetchProjectUser } from "../CreateTemplateModal/requests/fetchProjectUser";
var VERIFY_USER_ADDED_POLLING_INTERVAL = 2000;
var waitFor = function (delay) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(null);
    }, delay);
  });
};
export var waitUntilUserAdded = function (props) {
  return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2, , 4]);
          return [
            4 /*yield*/,
            fetchProjectUser({
              projectId: props.projectId,
              userId: props.userId,
            }),
          ];
        case 1:
          _a.sent();
          return [3 /*break*/, 4];
        case 2:
          e_1 = _a.sent();
          return [4 /*yield*/, waitFor(VERIFY_USER_ADDED_POLLING_INTERVAL)];
        case 3:
          _a.sent();
          return [
            2 /*return*/,
            waitUntilUserAdded({
              projectId: props.projectId,
              userId: props.userId,
            }),
          ];
        case 4:
          return [2 /*return*/, null];
      }
    });
  });
};
